import React, { FC } from 'react'

import { InputCaptionProps } from '@/types'
import { Typography } from '@/atoms/typography'

export const InputCaption: FC<InputCaptionProps> = ({
  error = false,
  ...props
}) => {
  return <Typography variant={'body-2'} tag={'span'} error={error} {...props} />
}
